import { useEffect, useState, useMemo } from 'react';

import { resolveTailwindScreens } from '@/lib/utils/tailwind-config-resolver';

export type Breakpoint = '2xl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs';

export function useMediaQuery(query: string | null): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined'
      ? !!query && window.matchMedia(query).matches
      : false,
  );

  useEffect(() => {
    if (!query) return;
    const mediasQuerries = window.matchMedia(query);
    const handler = (event: MediaQueryListEvent) => setMatches(event.matches);

    mediasQuerries.addEventListener('change', handler);

    setMatches(mediasQuerries.matches);

    return () => mediasQuerries.removeEventListener('change', handler);
  }, [query]);

  return matches;
}

export function useBreakpoint(breakpoint: Breakpoint): boolean {
  const screens = useMemo(() => resolveTailwindScreens(), []);
  const minWidth = screens[breakpoint];
  const mediaQuerry = minWidth ? `(min-width: ${minWidth})` : null;
  return useMediaQuery(mediaQuerry);
}
